import VueJsBridgePlugin from "./libs/plugin";
import defaultOptions from "./libs/default";
import Service, { setWhiteList } from "./libs/service";
import { isVue2 } from "vue-demi";
export const $fetch = Service;
export default {
  install(Vue, options) {
    const initConfig = Object.assign({}, defaultOptions, options);
    const bridge = new VueJsBridgePlugin(initConfig);
    let whiteListUrls = [];

    setWhiteList(whiteListUrls);

    // get whiteListUrls
    bridge
      .callHandler("getConfig")
      .then((res) => {
        // Set whiteList URLs
        whiteListUrls = res.whitelist;
        setWhiteList(whiteListUrls);
      })
      .catch((error) => {
        console.error("[Bridge] Verify error", error);
      });

    // register bridge handler
    const globalProps = {
      $bridge: {
        value: bridge,
      },
      $fetch: {
        value: Service,
      },
    };
    if (isVue2) {
      Object.defineProperties(Vue.prototype, globalProps);
    } else {
      Object.defineProperties(Vue.config.globalProperties, globalProps);
      Vue.provide("$bridge", bridge);
      Vue.provide("$fetch", Service);
    }
  },
};
